module.exports = __webpack_public_path__ + "static/media/price_label_promo.b23c2133.svg";